


























































import BaseDialog from '@/components/BaseDialog.vue';

import { PropType } from 'vue';
import { TAutoclickerScriptRecord, ValidationRules } from '@/api/schema';
import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  createAutoclickerScript,
  updateAutoclickerScript
} from '@/api/CopyStake/AutoClicker';

const defaultFormData = (): Partial<TAutoclickerScriptRecord> => {
  return {
    id: null,
    name: '',
    phrasesText: ''
  };
};

export default {
  name: 'CopyStakeAutoclickerPromptsModal',
  components: {
    BaseDialog
  },
  props: {
    promptData: {
      type: Object as PropType<Partial<TAutoclickerScriptRecord>>,
      default: null
    },
    language: {
      type: String
    },
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      formData: { ...defaultFormData() },
      isFormValid: true,
      loading: {
        processing: false
      }
    };
  },
  computed: {
    isNewConfig(): boolean {
      return !this.promptData;
    },
    isCopyConfig(): boolean {
      return !this.promptData?.id && this.promptData?.name;
    },
    isEditConfig(): boolean {
      return this.promptData?.id && this.promptData?.name;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    getTitle(): string {
      if (this.isCopyConfig) return 'Add Script from Copy';
      if (this.isEditConfig) return 'Edit Script';

      return 'Add New Script';
    },
    getSubmitText(): string {
      if (this.isCopyConfig) return 'Save as New';
      if (this.isEditConfig) return 'Save Changes';

      return 'Add Script';
    },

    rules(): ValidationRules {
      return {
        name: [(v: string) => vr.required(v, 'Script Name')],
        phrasesText: [(v: string) => vr.required(v, 'Script Text')]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetForm();

      if (!open) {
        return;
      }

      if (this.isEditConfig || this.isCopyConfig)
        this.formData = {
          ...this.promptData
        };
    }
  },
  methods: {
    async resetForm(): Promise<void> {
      await this.$refs.form?.reset();

      this.formData = { ...defaultFormData() };
    },

    async handleSubmit(): Promise<void> {
      await this.$refs.form.validate();

      if (!this.isFormValid || this.isLoading || !this.language) return;

      this.loading.processing = true;

      const cleanedPhrases = (this.formData.phrasesText || '')
        .toString()
        .trim();

      const payload = {
        name: this.formData.name,
        language: this.language,
        phrasesText: cleanedPhrases
      };

      if (this.isNewConfig || this.isCopyConfig) {
        createAutoclickerScript(payload)
          .then((data) => {
            this.$toast.success('AI Streamer Script created');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      } else {
        updateAutoclickerScript(this.promptData.id, payload)
          .then((data) => {
            this.$toast.success('AI Streamer Script updated');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
